import ValidateDefaults from 'validation/ValidateDefaults';

export default class ValidateBirthDate extends ValidateDefaults {
    constructor(obj) {
        super(obj);

        this.on = ['blur'];
        this.pageAttrKey = 'validation_birthdate';
    }

    validate(birthdate) {
        if (ValidateDefaults.isEmpty(birthdate)) {
            // May be optional - use in addition to ValidateRequired if required
            return true;
        }

        if (birthdate.length < 8) {
            return false;
        } else {
            let b = birthdate;
            const now = new Date();
            const currentDate = new Date(
                now.getFullYear(),
                now.getMonth() + 1,
                now.getDate(),
            ).getTime();
            const bDate = new Date(
                b.substring(b.length - 4),
                b.substring(0, 2),
                b.substring(2, 4),
            ).getTime();

            return currentDate > bDate;
        }
    }

    static defaultMessage() {
        return 'Invalid birth date.';
    }
}
